import './styles.scss';

import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { Menu } from '@nhl/nhl-react-ui/lib/Menu';
import '@nhl/nhl-react-ui/lib/Menu/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { sessionOperations } from '../../../redux/ducks/session';
import { mediaDarkLogo } from '../../../images/logos';
import { Logo, LogoContainer } from './styles';

/*
 @return

 element:
 A element class is required
 distance: (optional)
 The distance from the top of the page where you want the element to become fixed.
 index: (optional)
 The index of the element on the page, default is first element in the DOM tree.
 */
const isScrolledToTop = (element, distance, index) => {
    const perceivedTop = typeof distance !== 'undefined' ? distance : 0;
    const classIndex = typeof index !== 'undefined' ? index : 0;
    const elem = document.getElementsByClassName(element)[classIndex];

    if (elem) {
        const elemBottom = elem.getBoundingClientRect().bottom;
        return elemBottom <= perceivedTop;
    }
    return true;
};

window.onscroll = () => {
    if(document.querySelector('header nav') !== null) {
        const header = document.querySelector('header nav').classList;
        const mainSection = document.querySelector('.main-section').classList;

        if (!isScrolledToTop('header-scoreboard', 0, 0)) {
            header.remove('sticky');
            mainSection.remove('sticky');
        } else {
            header.add('sticky');
            mainSection.add('sticky');
        }
    }
};


const HeaderMenu = ({ authenticated, isAccountApp }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    const getAccountMenu = () => {
        if (isAccountApp) {
            return (
                <li>
                    <Link to="/auth/profile" title="Go to Profile" alt="Go to Profile" className="link">
                        <FontAwesomeIcon icon={['fas', 'user']} size="lg"/>
                    </Link>
                    {authenticated &&
                        <ul>
                            <li><Link to="/auth/profile" className="link">Profile</Link></li>
                            <li><Link to="/auth/subscriptions" className="link">Subscriptions</Link></li>
                            <li><Link to="/auth/password" className="link">Password</Link></li>
                        </ul>
                    }
                </li>
            );
        } else {
            return (
                <li>
                    <a href="/account/ui/auth/profile" title="Go to Profile" alt="Go to Profile" className="link">
                        <FontAwesomeIcon icon={['fas', 'user']} size="lg"/>
                    </a>
                    {authenticated &&
                        <ul>
                            <li><a href="/account/ui/auth/profile" className="link">Profile</a></li>
                            <li><a href="/account/ui/auth/subscriptions" className="link">Email Subscriptions</a></li>
                            <li><a href="/account/ui/auth/password" className="link">Password</a></li>
                        </ul>
                    }
                </li>
            );
        }
    };

    const mediaLogo = (
        <LogoContainer>
            {
                isAccountApp ? (
                    <a href="/">
                        <Logo src={mediaDarkLogo} alt="media logo"/>
                    </a>
                ) : (
                    <Link to="/">
                        <Logo src={mediaDarkLogo} alt="media logo"/>
                    </Link>
                )
            }
        </LogoContainer>
    );

    if (!authenticated) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(sessionOperations.logout());
    };

    const secondaryMenu = (
        <ul className="secondary-menu">
            {getAccountMenu()}
            {authenticated &&
            <li>
                <a onClick={handleSubmit} title="Sign Out" alt="Sign Out" className="link">
                    <FontAwesomeIcon icon={['fas', 'sign-out']} size="lg"/>
                </a>
            </li>
            }
        </ul>
    );

    return (
        <Menu
            darkTheme
            logo={mediaLogo}
            append={secondaryMenu}
            forceExternalLinks={isAccountApp}
            location={location}
            sendGoogleAnalyticsEventsForExternal={false}
        />
    )
};

export default HeaderMenu;
